import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import Price from '../../ui/price'
import { makeNumbersFarsi } from '../../utils/farsi'
import { API_BASE_URL } from 'config/api'
import { getProductImageUrl, getImageAlt } from 'utils/imageUtils'
import { ProductImage } from 'utils/imageUtils'

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: string
  changedAt: string | number | Date
}

interface CartItemsTypes {
  discount: number
  id: string
  orderId: string
  ownerId: string
  price: number
  product: Product
  productId: string
  quantity: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

interface Cart {
  createdAt: string
  currency: string
  customerId: string
  discount: number
  id: string
  isCancelled: boolean
  isDisputed: boolean
  items: CartItemsTypes[]
  paymentGatewayId: string | null
  receiverFirstName: string
  receiverLastName: string
  receiverTelephone: string
  refundType: string | null
  shipmentTrackingCode: number | null
  shippingAddressCityId: number
  shippingAddressLatitude: number | null
  shippingAddressLongitude: number | null
  shippingAddressPostalCode: string
  shippingAddressText: string
  shippingPrice: number
  shippingRateId: string | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  totalRefunded: number
  transactionId: string | null
  transactionTrackingCode: string | null
  updatedAt: string
  trackingUrl: string | null
  vat: number
  cartItemIdsBeingRemoved: []
}

export const CartItems = ({ cart, setCart }: { cart: Cart; setCart: any }) => {
  let isCartPaymentDone = cart.status !== 'checkout'

  if (!cart.items || cart.items.length === 0) {
    if (isCartPaymentDone) {
      return (
        <div className='w-full my-4 h-auto border p-4 rounded-md bg-[#81a1c1] text-white'>
          آیتمی وجود ندارد
        </div>
      )
    } else {
      return <div>سبد خرید شما خالی است</div>
    }
  }

  const renderItemImage = (cartItem: { product: Product }) => {
    const imageUrl = getProductImageUrl(cartItem.product, true) // Use thumbnail for cart

    if (imageUrl) {
      const firstImage = Array.isArray(cartItem.product.images)
        ? cartItem.product.images[0]
        : typeof cartItem.product.image === 'object' && cartItem.product.image !== null
          ? (cartItem.product.image as ProductImage)
          : undefined
      return (
        <img
          alt={getImageAlt(firstImage?.alt, cartItem.product.title, 0)}
          title={firstImage?.title || getImageAlt(firstImage?.alt, cartItem.product.title, 0)}
          className='w-24 ml-4 rounded-md'
          src={imageUrl}
          loading='lazy'
        />
      )
    }

    return null
  }

  const renderItemTitle = (cartItem: { product: { title: string } }) => {
    let title = cartItem.product.title

    return <h3>کتاب {title} </h3>
  }

  const renderItemQuantity = (cartItem: { quantity: number }) => {
    let quantity = cartItem.quantity

    return <h3>تعداد: {makeNumbersFarsi(quantity)} عدد</h3>
  }

  const removeItemFromCart = async (itemId: string) => {
    let url = `${API_BASE_URL}/orders/${cart.id}/items/${itemId}`
    const result = await axios.delete(url)
    if (result) {
      if (cart.items?.length === 1) {
        localStorage.removeItem('cart')
        setCart(result.data.items)
        window.dispatchEvent(new Event('cart-changed'))
      } else if (cart && cart.items.length > 1) {
        localStorage.removeItem('cart')
        setCart(result.data)
        localStorage.setItem('cart', JSON.stringify(result.data))
        window.dispatchEvent(new Event('cart-changed'))
      }
    }
  }

  const renderRemoveItemFromCartButton = (itemId: string) => {
    return (
      <button
        className='remove-button'
        onClick={() => removeItemFromCart(itemId)}
      >
        <FontAwesomeIcon
          icon={faTrash}
          style={{ fontSize: 30, marginLeft: 12, color: '#bf616a' }}
        />
      </button>
    )
  }

  return (
    <ul className='border rounded-md'>
      {cart.items.map((item) => (
        <li
          className='border-b-2 last:border-b-0 p-6 flex justify-between w-full'
          key={item.id}
        >
          <div className='flex flex-col md:flex-row items-start md:items-center w-[80%]'>
            <div className='flex items-center justify-center mx-0 my-2 md:my-0 md:mx-4'>
              {renderItemImage(item)}
            </div>
            <div className='flex items-start my-4 md:my-0 md:items-center flex-col md:flex-row  justify-between w-full'>
              {renderItemTitle(item)}
              {renderItemQuantity(item)}

              <Price
                value={item.price}
                currencyCode={cart.currency}
                alternativeCurrencyCode={true}
              />
            </div>
          </div>

          {renderRemoveItemFromCartButton(item.id)}
        </li>
      ))}
    </ul>
  )
}
